import React, { Component } from "react";
import PropTypes from "prop-types";
import { toastr } from "react-redux-toastr";
import { Formik } from "formik";

import Loader from "src/components/Loader";
import TextInput from "src/components/UI/TextInput";
import { getErrorMessage } from "src/utils/helpers";
import { BeatLoader } from "react-spinners";
import StripeOnboardingWizard from "../PaymentProviderSettings/StripeOnboardingWizard";
import axiosInstance from "../../../utils/axios-instance";

class SingleProviderAndConfigurationsComponent extends Component {
  state = {
    newProviderSet: false,
    providerChanged: false,
    currProvider: null,
    formChanged: false,
    status: null,
    loading: true,
    showStripeOnboarding: false,
    stripeConnectAccountId: null,
    stripeStatusChecked: false,
    stripeStatusValid: false,
    checkingStatus: false,
  };

  componentDidMount() {
    this.setState({ loading: true });
    this.props.getCurrentProviderId().then((resp) => {
      this.props.getProviderConfigurationById(resp.data.id).then((configResp) => {
        this.setState({
          currProvider: resp.data.id,
          loading: false
        }, () => {
          const dummySetSubmitting = () => {};
          const initialValues = {
            providerId: resp.data.id,
            providerConfiguration: configResp.data
          };
          if (resp.data.id === 'STRIPE') {
            this.checkStripeConnectAccountId(configResp.data);
          } else {
            this.testProviderConfiguration({ setSubmitting: dummySetSubmitting, values: initialValues });
          }
        });
      });
    });

    this.props.getAllProviderIds();
  }

  componentWillUnmount() {
    this.props.clearAllProviderIds();
    this.props.clearAllProviders();
    this.props.clearProviderById();
  }

  handleSubmit = (values, actions) => {
    actions.setSubmitting(false);
  };

  checkStripeConnectAccountId = (providerConfiguration) => {
    if (providerConfiguration && providerConfiguration.properties && Array.isArray(providerConfiguration.properties)) {
      const connectAccountIdProperty = providerConfiguration.properties.find(
        prop => prop.key === 'payment.provider.stripe.connect.account.id'
      );

      const hasConnectAccountId = connectAccountIdProperty &&
                                 connectAccountIdProperty.value &&
                                 connectAccountIdProperty.value.trim() !== 'NOVALUE';

      if (hasConnectAccountId) {
        this.setState({
          stripeConnectAccountId: connectAccountIdProperty.value,
          stripeStatusChecked: false,
          stripeStatusValid: false,
          checkingStatus: true,
          showStripeOnboarding: false
        }, () => {
          this.handleVerifyStripeStatus();
        });
      } else {
        this.setState({
          showStripeOnboarding: true,
          stripeConnectAccountId: null,
          stripeStatusChecked: true,
          stripeStatusValid: false,
          checkingStatus: false,
          status: false
        });
      }
    } else {
      this.setState({
        showStripeOnboarding: true,
        stripeConnectAccountId: null,
        stripeStatusChecked: true,
        stripeStatusValid: false,
        checkingStatus: false,
        status: false
      });
    }
  };

  handleStripeOnboardingComplete = () => {
    this.props.getProviderConfigurationById('STRIPE').then((configResp) => {
      this.checkStripeConnectAccountId(configResp.data);
    });
  };

  handleStripeWizardComplete = () => {
    this.setState({
      showStripeOnboarding: false,
      stripeStatusChecked: true,
      stripeStatusValid: true
    });
  };

  onCurrentProviderChangeHandler = (name, value, formProps) => {

    this.setState({
      loading: true,
      showStripeOnboarding: false,
      stripeStatusChecked: false,
      stripeStatusValid: false,
      stripeConnectAccountId: null
    });
    formProps.setFieldValue("providerId", value);
    this.setState({formChanged: false})
    if (value) {
      this.props.getProviderConfigurationById(value).then((resp) => {
        formProps.setFieldValue("providerConfiguration", resp.data);

        if(value === this.state.currProvider){
          const dummySetSubmitting = () => {};
          const initialValues = {
            providerId: value,
            providerConfiguration: resp.data
          };
          this.setState({ providerChanged: false, loading: false });
          this.testProviderConfiguration({ setSubmitting: dummySetSubmitting, values: initialValues });
        } else {
          this.setState({ newProviderSet: true, providerChanged: true, loading: false }, () => {
            const dummySetSubmitting = () => {};
            const initialValues = {
              providerId: value,
              providerConfiguration: resp.data
            };
            this.testProviderConfiguration({ setSubmitting: dummySetSubmitting, values: initialValues });
          });
        }
        if (value === 'STRIPE') {
          this.checkStripeConnectAccountId(resp.data);
        }

      }).catch((error) => {
        console.error('Error getting provider configuration:', error);
        this.setState({ loading: false });
      });
    } else {
      formProps.setFieldValue("providerConfiguration", null);
      this.setState({ loading: false });
    }
  };

  saveProviderConfiguration = ({ setSubmitting, values }) => {
    setSubmitting(true);

    this.props
      .saveProviderConfiguration(values.providerId, values.providerConfiguration)
      .then((response) => {
        if (response.success === false) {
          toastr.error(getErrorMessage(response).message, { position: "top-center" });
        } else {
          const message = `${this.props.title} configuration is updated successfully`;

          toastr.success(message, { timeOut: 3000, position: "top-center" });


          this.testProviderConfiguration({ setSubmitting, values });

          this.props
            .getProviderConfigurationById(values.providerId)
            .then((resp) => {
              setSubmitting(false);
              this.setState({ providerChanged: false, currProvider: values.providerId, formChanged: false });
            })
            .catch((error) => {
              console.error(error);
              setSubmitting(false);
            });
        }
      })
      .catch((e) => {
        toastr.error("Something went wrong", { timeOut: 5000, position: "top-center" });
        setSubmitting(false);
      });
  };

  testProviderConfiguration = ({ setSubmitting, values }) => {
    setSubmitting(true);
    this.setState({loading: true})

    if (values.providerId === 'STRIPE') {
      this.setState({loading: false});
      setSubmitting(false);
      return;
    }

    this.props
      .testProviderConfiguration(values.providerId, values.providerConfiguration)
      .then((response) => {
        this.setState({status: response.data.success})
        const error = getErrorMessage(response.data);
        const errorMessage = error.hasErrorDetail ? error.message : `${this.props.title} configuration is valid.`;
        if (response.data.success === false) {
          toastr.error(errorMessage, { timeOut: 0, position: "top-center" });
        } else {
          toastr.success(errorMessage, { position: "top-center" });
        }
        this.setState({loading: false})
      })
      .catch((err) => {
        const error = getErrorMessage(err);
        const errorMessage = error.hasErrorDetail ? error.message : `${this.props.title} configuration is valid.`;
        toastr.error(errorMessage, { timeOut: 0, position: "top-center" });
        this.setState({loading: false})
      })
      .finally(() => setSubmitting(false));
  };

  retestConfiguration = () => {
    const { currProvider, providerConfiguration } = this.state;
    if (currProvider && providerConfiguration) {
      const dummySetSubmitting = () => {};
      const values = { providerId: currProvider, providerConfiguration };
      this.testProviderConfiguration({ setSubmitting: dummySetSubmitting, values });
    }
  };

  onSaveButtonClick = (saveFunction, updatedProps, formProps) => {
    const newProvider = this.state.newProviderSet
      ? this.props.providerUiOptions[formProps.values.providerId]?.label
      : null;

    this.props.showModal("CONFIRM_CHANGES_AND_ACTION_MODAL", {
      title: "Save Configuration",
      text: (
        <>
          Are you sure you want to make these changes?
          <br />
          {newProvider && `${this.props.title} has been changed to "${newProvider}"`}
        </>
      ),
      changes: updatedProps,
      action: () => saveFunction(formProps),
    });
  };

  shouldShowConfiguration = () => {
    return this.props.currentProviderId !== 'STRIPE';
  };

  handleVerifyStripeStatus = async () => {
    if (!this.state.stripeConnectAccountId) {
      toastr.error('No Stripe Connect account ID found', { position: "top-center" });
      throw new Error('No Stripe Connect account ID found');
    }

    this.setState({ checkingStatus: true });

    try {
      const response = await axiosInstance.get(
        `/payment-provider/stripe/connect/status/account/${this.state.stripeConnectAccountId}`
      );

      if (response && response.data && response.data.success) {
        const isValid = response.data.onboarding_complete ||
                       response.data.onboardingComplete ||
                       response.data.charges_enabled ||
                       response.data.chargesEnabled ||
                       response.data.details_submitted ||
                       response.data.detailsSubmitted ||
                       response.data.payouts_enabled ||
                       response.data.payoutsEnabled ||
                       response.data.complete ||
                       response.data.status === 'complete' ||
                       response.data.status === 'COMPLETE' ||
                       false;

        this.setState({
          stripeStatusChecked: true,
          stripeStatusValid: isValid,
          checkingStatus: false,
          showStripeOnboarding: !isValid,
          status: isValid
        });

        if (isValid) {
          toastr.success('Stripe Connect account verified successfully!', { position: "top-center" });
        } else {
          // toastr.info('Account found but onboarding is incomplete. Continue setup in the wizard.', { position: "top-center" });
        }
        return Promise.resolve();
      } else {
        toastr.error('Failed to check Stripe Connect status', { position: "top-center" });
        this.setState({
          checkingStatus: false,
          stripeStatusChecked: true,
          showStripeOnboarding: true,
          status: false
        });
        throw new Error('Failed to check Stripe Connect status');
      }
    } catch (error) {
      toastr.error('Failed to verify Stripe status.', { position: "top-center" });
      this.setState({
        checkingStatus: false,
        stripeStatusChecked: true,
        showStripeOnboarding: true,
        status: false
      });
      throw error;
    }
  };

  handleStartNewOnboarding = () => {

    this.setState({
      showStripeOnboarding: true,
      stripeConnectAccountId: null,
      stripeStatusChecked: false,
      stripeStatusValid: false
    });
  };

  render() {
    const { providerUiOptions, isLoading, currentProviderId, providers, allProviderIds } = this.props;
    const { loading, showStripeOnboarding } = this.state;
    const effectiveCurrentProviderId = currentProviderId === undefined ? 'STRIPE' : currentProviderId;

    const providerIdOptions = allProviderIds
      ? allProviderIds
          .map((mid) => ({ label: mid, value: mid, ...(providerUiOptions[mid] || {}) }))
          .sort((a, b) => (a.order || 0) - (b.order || 0))
          .filter((o) => o.value !== 'STRIPE' || currentProviderId === 'STRIPE' || currentProviderId === undefined)
      : [];

    return (
      <div className="container mb-4">
        <Formik
          initialValues={{
            providerId: currentProviderId,
            providerConfiguration: currentProviderId && providers && providers[currentProviderId],
          }}
          enableReinitialize={true}
          onSubmit={this.handleSubmit}
        >
          {(formProps) => {
            const { handleChange, handleSubmit, handleBlur, values, isSubmitting, setFieldValue, initialValues } = formProps;

            const originalProviderConfiguration = providers && providers[values && values.providerId];
            const updatedProps = [];

            originalProviderConfiguration &&
              values.providerConfiguration &&
              originalProviderConfiguration.properties.forEach((origProp) => {
                const currProp = values.providerConfiguration.properties.find(
                  (currProp) => currProp.key === origProp.key
                );
                if (currProp && currProp.value !== origProp.value) {
                  updatedProps.push({ key: currProp.key, oldVal: origProp.value, newVal: currProp.value });
                }
              });

            return (
              <>
                <form onSubmit={handleSubmit}>
                  {isLoading && <Loader />}

                  <section className="form-vertical container">
                    <div className="d-flex flex-row justify-content-around align-items-center">
                      {providerIdOptions.map((o) => (
                        <div key={`provider_${o.value}`}>
                          <label className="text-center">
                            <div
                              className="d-flex justify-content-center align-items-center"
                              style={{ width: "180px", height: "120px", padding: "20px", boxSizing: "border-box" }}
                            >
                              <img
                                src={o.icon}
                                alt={o.label}
                                style={{
                                  maxWidth: "100%",
                                  maxHeight: "100%",
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                }}
                              />
                            </div>
                            <div className="d-inline-block ml-4 form-check checkbox-slider checkbox-slider--b-flat">
                              <label>
                                <input
                                  type="checkbox"
                                  name="providerId"
                                  checked={values.providerId === o.value}
                                  value={o.value}
                                  onChange={(event) =>
                                    event.target.checked &&
                                    this.onCurrentProviderChangeHandler(event.target.name, event.target.value, {
                                      values,
                                      setFieldValue,
                                    })
                                  }
                                />
                                <span>&nbsp;</span>
                              </label>
                            </div>
                          </label>
                        </div>
                      ))}
                    </div>

                    <div className="d-flex align-items-center justify-content-end pr-3">
                      {loading ? (
                        <BeatLoader
                          color="#6ab3c2"
                          size={9}
                        />
                      ) : (
                        <>
                          <span className={`${this.state.status ? "text-success pr-3" : "text-danger pr-3"}`}>
                            Connection Status: {this.state.status ? "Valid" : "Not Valid"}
                          </span>
                          <button
                            className="btn btn-link p-0"
                            onClick={() => {
                              if (values.providerId === 'STRIPE') {
                                this.handleVerifyStripeStatus();
                              } else {
                                this.testProviderConfiguration(formProps);
                              }
                            }}
                            disabled={values.providerId === 'STRIPE' && this.state.checkingStatus}
                            style={{ color: "inherit", textDecoration: "inherit" }}
                            title="Refresh status"
                          >
                            {(values.providerId === 'STRIPE' && this.state.checkingStatus) ? (
                              <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                            ) : (
                              <i className="fas fa-fw fa-sync" aria-hidden="true"></i>
                            )}
                          </button>
                        </>
                      )}
                    </div>

                    {/* Stripe Onboarding Wizard */}
                    {values.providerId === 'STRIPE' && (
                      <div className="mt-4">

                        {this.state.checkingStatus ? (
                          <div className="text-center py-4">
                            <div className="spinner-border text-primary mb-3" role="status" style={{ width: '3rem', height: '3rem' }}>
                              <span className="sr-only">Loading...</span>
                            </div>
                            <p>Checking your Stripe Connect account status...</p>
                            <p><small className="text-muted"><strong>Note:</strong> If onboarding is incomplete, the wizard will continue from the appropriate step.</small></p>
                          </div>
                        ) : showStripeOnboarding ? (
                          <div>
                            {StripeOnboardingWizard ? (
                              <StripeOnboardingWizard
                                onComplete={this.handleStripeWizardComplete}
                                onOnboardingComplete={this.handleStripeOnboardingComplete}
                                existingAccountId={this.state.stripeConnectAccountId}
                              />
                            ) : (
                              <div className="alert alert-danger">
                                <strong>Error:</strong> StripeOnboardingWizard component not found!
                                <br />
                                Import path: ../PaymentProviderSettings/StripeOnboardingWizard
                              </div>
                            )}
                          </div>
                        ) : this.state.stripeConnectAccountId && this.state.stripeStatusValid ? (
                          <div>
                            <div className="card">
                              <div className="card-body text-center">
                                <div className="mb-3">
                                  <img src="/images/Stripe.svg" alt="Stripe" style={{ maxWidth: "150px", maxHeight: "60px" }} />
                                </div>
                                <div className="mb-4">
                                  <i className="fas fa-check-circle text-success" style={{ fontSize: '3rem' }}></i>
                                </div>
                                <h5 className="text-success">Setup Complete!</h5>
                                <p className="mb-4">
                                  Your Stripe Connect integration is active and ready to process payments.
                                </p>

                                {/* Refresh Status and Start New Setup - use top-right refresh icon for status */}
                                {/*<div className="btn-group" role="group">*/}
                                {/*  <button*/}
                                {/*    type="button"*/}
                                {/*    className="btn btn-outline-primary"*/}
                                {/*    onClick={this.handleVerifyStripeStatus}*/}
                                {/*    disabled={this.state.checkingStatus}*/}
                                {/*  >*/}
                                {/*    {this.state.checkingStatus && (*/}
                                {/*      <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true" />*/}
                                {/*    )}*/}
                                {/*    <i className="fas fa-sync mr-2"></i>*/}
                                {/*    {this.state.checkingStatus ? 'Checking...' : 'Refresh Status'}*/}
                                {/*  </button>*/}
                                {/*  <button*/}
                                {/*    type="button"*/}
                                {/*    className="btn btn-outline-secondary"*/}
                                {/*    onClick={() => {*/}
                                {/*      this.handleStartNewOnboarding();*/}
                                {/*    }}*/}
                                {/*  >*/}
                                {/*    <i className="fas fa-plus mr-2"></i>*/}
                                {/*    Start New Setup*/}
                                {/*  </button>*/}
                                {/*</div>*/}
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="alert alert-warning">
                            <strong>Unexpected State</strong>
                            <br />
                            Unable to determine Stripe account status. Please try refreshing the page.
                          </div>
                        )}
                      </div>
                    )}

                    {!isLoading && this.state.loading && values.providerId && (
                      <div className="card-vertical card-plane">
                        <div className="card-body text-center py-5">
                          <BeatLoader color="#6ab3c2" size={12} />
                          <p className="mt-3 mb-0 text-muted">Loading configuration...</p>
                        </div>
                      </div>
                    )}

                    {!isLoading && !this.state.loading && values.providerConfiguration &&
                     (values.providerId !== 'STRIPE' || (values.providerId === 'STRIPE' && !this.state.showStripeOnboarding && this.state.stripeStatusChecked)) && (
                      <div className="card-vertical card-plane">
                        <div className="card-body">
                          <div className="plan-header plan-header-centered">
                            <span className="plan-title"></span>
                          </div>
                          <div className="plan-body">
                          <div className="form-group service-wrapper">
                              {values &&
                                values.providerConfiguration &&
                                values.providerConfiguration.properties.map((prop, idx) => {
                                  const fieldName = `providerConfiguration.properties[${idx}].value`;

                                  return (
                                    <TextInput
                                      key={`config_${prop.key}`}
                                      label={prop.description || prop.key}
                                      type="text"
                                      name={fieldName}
                                      onChange={(event) => {
                                        handleChange(event);
                                        const fieldName = event.target.name;
                                        const fieldValue = event.target.value;
                                        const index = parseInt(fieldName.split('.')[1].replace('properties[', '').replace(']', ''), 10);
                                        const actualFieldName = values.providerConfiguration.properties[index]?.key;
                                        const initialFieldValue = initialValues.providerConfiguration.properties.find(prop => prop.key === actualFieldName)?.value;
                                        this.setState({ formChanged: fieldValue !== initialFieldValue });
                                      }}
                                      onBlur={handleBlur}
                                      value={prop.value || ""}
                                      disabled={isSubmitting}
                                      autocomplete={false}
                                      helperText={prop.key}
                                    />
                                  );
                                })}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Only show save button if showing configuration (hide while loading new provider config) */}
                    {!this.state.loading && (values.providerId !== 'STRIPE' || (values.providerId === 'STRIPE' && !this.state.showStripeOnboarding && this.state.stripeStatusChecked)) && (
                      <div className="plan-footer mt-2" style={{ textAlign: "right" }}>
                        <button
                          onClick={() => this.onSaveButtonClick(this.saveProviderConfiguration, updatedProps, formProps)}
                          disabled={(!this.state.providerChanged && !this.state.formChanged) || isLoading || isSubmitting}
                          type="button"
                          className="btn btn-primary"
                        >
                          {isSubmitting && (
                            <span
                              className="spinner-border spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                              style={{ marginRight: "5px" }}
                            />
                          )}
                          Save
                        </button>
                      </div>
                    )}
                  </section>
                </form>
              </>
            );
          }}
        </Formik>
      </div>
    );
  }
}

SingleProviderAndConfigurationsComponent.propTypes = {
  providerUiOptions: PropTypes.object,
  title: PropTypes.string,
  getCurrentProviderId: PropTypes.func,
  getProviderConfigurationById: PropTypes.func,
  getAllProviderIds: PropTypes.func,
  clearProviderById: PropTypes.func,
  clearAllProviders: PropTypes.func,
  clearAllProviderIds: PropTypes.func,
  currentProviderId: PropTypes.string,
  allProviderIds: PropTypes.array,
  providers: PropTypes.object,
  saveProviderConfiguration: PropTypes.func,
  testProviderConfiguration: PropTypes.func,
  isLoading: PropTypes.bool,
  showModal: PropTypes.func,
};

export default SingleProviderAndConfigurationsComponent;
